<template>
  <section
    v-if="value !== null"
    class="data pega-print-break-inside-avoid"
  >
    <div :id="targetId">
      <p
        class="h-style-02"
        :class="titleClass"
      >
        {{ title }}
      </p>
      <job-preview-content-data-tooltip />
      <div class="palette">
        <div
          class="colorOuter"
          :class="colorClass"
        >
          <div
            class="colorInner"
            :style="`transform: rotate(${rotateTurn}turn);`"
          />
        </div>
        <div class="centerOverlay fwB">
          <span class="head mt10 tc">女性</span>
          <span class="data tr">{{ value }}</span>
          <span class="percent">％</span>
          <div class="north" />
          <div
            class="separator"
            :style="`transform: rotate(${rotateTurn}turn) translate(0px, -50px);`"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContentDataTooltip from '@/components/atoms/JobPreviewContentDataTooltip'
import jobPreviewGraph from '@/lib/jobPreviewGraph'

export default {
  components: {
    JobPreviewContentDataTooltip
  },
  mixins: [jobPreviewGraph],
  props: {
    targetId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: null
    },
    titleClass: {
      type: String,
      default: ''
    }
  }
}
</script>
